import { jsx as u } from "react/jsx-runtime";
import { createContext as b, useMemo as k, useState as h, useEffect as f, useContext as G } from "react";
import { useGrowthBook as v, GrowthBook as x, GrowthBookProvider as y, useFeatureValue as E } from "@growthbook/growthbook-react";
import { uiEventEmitter as m } from "@made-people/grease-ui-events";
import { ManagedPropsProvider as R } from "@made-people/managed-props";
import { flattener as C } from "@made-people/flatten-object";
import { createEventEmitter as U } from "@made-people/grease-event-emitter";
function g(e) {
  const t = e.getFeatures();
  return Object.keys(t).sort().map((r) => {
    var o;
    return {
      featureId: r,
      value: e.getFeatureValue(
        r,
        (o = t[r]) == null ? void 0 : o.defaultValue
      )
    };
  });
}
const P = b(void 0), V = (e) => {
  const t = v(), r = k(
    () => e.activeFeatures ?? g(t),
    [t]
  ), [o, i] = h(r);
  return f(() => {
    const s = t.subscribe(() => {
      i((n) => {
        const a = g(t);
        return S(n, a) ? n : a;
      });
    });
    return () => s == null ? void 0 : s();
  }, [t]), /* @__PURE__ */ u(P.Provider, { value: o, children: e.children });
}, O = () => G(P);
function S(e, t) {
  var r, o, i, s;
  if (e === t)
    return !0;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (((r = e[n]) == null ? void 0 : r.featureId) !== ((o = t[n]) == null ? void 0 : o.featureId) || !Object.is((i = e[n]) == null ? void 0 : i.value, (s = t[n]) == null ? void 0 : s.value))
      return !1;
  return !0;
}
const p = b(void 0), j = (e) => /* @__PURE__ */ u(
  p.Provider,
  {
    value: e.viewedExperiments,
    children: e.children
  }
);
function A() {
  return G(p);
}
function D(e, t) {
  const [r, o] = h(
    t
  );
  return f(() => {
    o(t);
  }, [t]), f(() => {
    if (e)
      return e.subscribe((i, s) => {
        o((n) => {
          if (s.inExperiment)
            return {
              ...n,
              [i.key]: s.key
            };
          if (!n || !(i.key in n))
            return n;
          const a = { ...n };
          return delete a[i.key], a;
        });
      });
  }, [e]), r;
}
const I = (e) => {
  const t = k(() => {
    if (e.client)
      return e.client;
    if (!e.payload)
      throw new Error(
        "GreaseGrowthbookClientProvider: You must provide either a client or payload"
      );
    const o = [], i = e.attributes ?? {};
    if (typeof document < "u") {
      const s = e.cookieName ?? "gbuuid", n = document.cookie.split("; ").find((c) => c.startsWith(s + "=")), a = n ? (
        // @ts-expect-error - TS doesn't know that match is not undefined
        decodeURIComponent(n.split("=")[1])
      ) : null;
      i.id = a;
    }
    return new x({
      ...e.clientOptions,
      attributes: i,
      plugins: o
    }).initSync({
      payload: e.payload
    });
  }, [
    e.client,
    e.clientOptions,
    e.attributes,
    e.payload,
    e.cookieName
  ]), r = D(
    t,
    e.viewedExperiments
  );
  return f(() => {
    if (!t)
      return;
    const o = (i) => {
      const s = new URL(window.location.origin + i.to);
      t.setURL(s.toString()), t.setAttributes({
        ...t.getAttributes(),
        url: s.toString(),
        urlPathname: s.pathname
      });
    };
    return m.on("routeChanged", (i) => o(i)), () => {
      m.off("routeChanged", (i) => o(i));
    };
  }, [t]), /* @__PURE__ */ u(y, { growthbook: t, children: /* @__PURE__ */ u(
    j,
    {
      viewedExperiments: r,
      children: e.children
    }
  ) });
};
function X() {
  try {
    return v();
  } catch {
    return;
  }
}
function Z(e, t) {
  try {
    return E(e, t);
  } catch {
    return;
  }
}
const Q = (e) => {
  const t = A();
  return e.forceDisplay === !0 || t && t[e.experimentId] === e.variationId ? e.children : null;
};
function N(e, t) {
  const r = C(t.propDelimiter), i = e.filter(
    (s) => s.featureId.includes(t.componentNameDelimiter)
  ).reduce(
    (s, n) => {
      const [a, c] = n.featureId.split(
        t.componentNameDelimiter
      );
      return a && c && (s[a] || (s[a] = {}), s[a][c] = n.value), s;
    },
    {}
  );
  return Object.fromEntries(
    Object.entries(i).map(([s, n]) => {
      const a = r.unflatten(n);
      return [s, a];
    })
  );
}
const L = (e) => {
  var a, c;
  const t = O(), [r, o] = h(
    (e.deferredComponentNames ?? []).reduce((d, l) => (d[l] = null, d), {})
  ), i = e.componentNameDelimiter ?? "::", s = e.propDelimiter ?? "_";
  f(() => {
    if (t != null && t.length) {
      const d = N(t, {
        componentNameDelimiter: i,
        propDelimiter: s
      });
      o(d);
    }
  }, [t]);
  const n = {
    fallbackProps: (a = e.managedProps) == null ? void 0 : a.fallbackProps,
    overrideProps: (c = e.managedProps) == null ? void 0 : c.overrideProps,
    deferredOverrideProps: r
  };
  return /* @__PURE__ */ u(R, { value: n, children: e.children });
}, ee = (e) => /* @__PURE__ */ u(I, { ...e.clientProviderProps, children: /* @__PURE__ */ u(
  V,
  {
    ...e.activeFeaturesProviderProps,
    children: /* @__PURE__ */ u(
      L,
      {
        deferredComponentNames: e.deferredComponentNames,
        managedProps: e.managedProps,
        children: e.children
      }
    )
  }
) }), F = (e) => typeof e == "object" && e !== null && !Array.isArray(e), M = (e) => F(e) && typeof e.experimentId == "string" && typeof e.variationId == "string", W = (e) => {
  if (!(!e || Object.keys(e).length === 0))
    return btoa(JSON.stringify(e));
}, te = (e) => {
  try {
    const t = JSON.parse(atob(e));
    return Array.isArray(t) ? t.filter(M) : F(t) ? Object.entries(t).flatMap(
      ([r, o]) => typeof o == "string" ? [{ experimentId: r, variationId: o }] : []
    ) : [];
  } catch {
    return [];
  }
}, re = (e, t) => {
  const r = new URL(e.toString());
  return r.searchParams.delete(t), `${r.pathname}${r.search}${r.hash}`;
}, B = "redirect-test:";
function $(e) {
  return typeof e == "object" && e !== null && "searchRegex" in e && "replaceWith" in e && typeof e.searchRegex == "string" && typeof e.replaceWith == "string";
}
function J(e, t) {
  const r = Object.keys(e.getFeatures()).filter((o) => o.startsWith(t)).map((o) => {
    const i = e.getFeatureValue(o, void 0);
    if ($(i))
      return { key: o, value: i };
  }).filter(
    (o) => typeof o < "u"
  );
  if (r.length !== 0)
    return r.length > 1 && console.warn(
      "Received multiple redirect tests from Growthbook. Picking the first one."
    ), r[0];
}
const w = (e, t) => {
  const r = new URL(e.toString());
  return t && r.searchParams.delete(t), r.toString();
};
function oe({
  requestUrl: e,
  growthbook: t,
  viewedExperiments: r,
  viewedExperimentsParamName: o,
  preserveQueryParams: i,
  redirectFeaturePrefix: s = B
}) {
  const n = J(t, s);
  if (!n)
    return;
  const a = new URL(e);
  let c;
  try {
    const l = new RegExp(n.value.searchRegex);
    if (!l.test(a.toString()))
      return;
    c = new URL(
      a.toString().replace(l, n.value.replaceWith)
    );
  } catch (l) {
    console.error("Error building redirect URL:", l);
    return;
  }
  if (i == null || i(a, c), w(c, o) === w(a, o))
    return;
  const d = W(r);
  return d && o && c.searchParams.set(o, d), c;
}
const ne = U();
export {
  V as GreaseGrowthbookActiveFeaturesProvider,
  I as GreaseGrowthbookClientProvider,
  Q as GreaseGrowthbookExperimentContainer,
  L as GreaseGrowthbookManagedPropsProvider,
  ee as GreaseGrowthbookProvider,
  j as GreaseGrowthbookViewedExperimentsProvider,
  W as encodeGreaseGrowthbookViewedExperimentsParam,
  oe as getGreaseGrowthbookRedirectUrl,
  g as getGrowthbookFeaturesFromClient,
  re as getUrlWithoutGreaseGrowthbookViewedExperimentsParam,
  ne as greaseGrowthbookEventEmitter,
  P as growthbookActiveFeaturesContext,
  te as parseGreaseGrowthbookViewedExperimentsParam,
  N as resolveGrowthbookManagedProps,
  X as useGreaseGrowthbook,
  O as useGreaseGrowthbookActiveFeatures,
  Z as useGreaseGrowthbookFeatureValue,
  A as useGreaseGrowthbookViewedExperiments,
  D as useGreaseGrowthbookViewedExperimentsState
};
//# sourceMappingURL=lib.es.js.map
